// ======================================================================
// File Name       : ContentNotificationSearchResult
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// =======================================================================
import React from 'react';
import { Form, FormControl, Col, Button, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PaginationCustom from '../Pagination';
import TableHead, { setSortState } from '../TableHead';
import * as Path from '../../constants/PathConstants';
import CustomButton from '../button/CustomButton';

const ContentNotificationSearchResult = ({
  handleDownloadMessage,
  handleSearchMessage,
  notifyMessageSetList,
  handleSortState,
  recordNum,
  getStartEndData,
  startPosition,
  searchData,
}) => {
  const thead = [
    { title: '通知メッセージ識別ID', sortBy: 0, width: 250 },
    { title: '通知メッセージ名', sortBy: 1 },
    { title: '操作', sortBy: null, width: 150 },
    { title: 'ダウンロード', sortBy: null, width: 150 },
  ];
  let data = thead;
  if (searchData) {
    const sortBy = searchData.notifyMessageSortType;
    const sortState = searchData.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }
  const onDownload = (event) => {
    const { id } = event.target;
    handleDownloadMessage(id);
  };
  // table data
  let notifyMessageTableData = null;
  if (notifyMessageSetList) {
    notifyMessageTableData = notifyMessageSetList.map((notifyMessagetData, index) => {
      const linkEdit = `/${Path.CONTENT}/${Path.CONTENT_DRILL_NOTIFICATION}/${notifyMessagetData.notifyMessageSetSecernId}`;
      return (
        <tr key={index}>
          <td>{notifyMessagetData.notifyMessageSetSecernId}</td>
          <td>{notifyMessagetData.notifyMessageSetName}</td>
          <td className="text-center">
            <Link className="btn btn-primary btn-120 margin-bottom-5" role="button" to={{ pathname: linkEdit }}>詳細・編集</Link><br />
          </td>
          <td className="text-center">
            <Button
              id={notifyMessagetData.notifyMessageSetSecernId}
              onClick={onDownload.bind(this)}
              variant="primary"
              className="btn-96"
            >
            ダウンロード
            </Button>
          </td>
        </tr>
      );
    });
  }
  return (
    <div>
      <Form className='form-horizontal'>
        <Form.Group className="form-info text-center">
          <Col sm={12} className="text-center">
            <CustomButton
              btnStyle="btn btn-primary btn-96 margin-top-10"
              handleClick={handleSearchMessage.bind(this)}
              text="検索"
              iconClass="bi bi-search"
            />
          </Col>
        </Form.Group>
        <Form.Group>
          <Col sm={12}>
            <PaginationCustom
              className="float-end"
              recordNum={recordNum}
              handlePageSelect={getStartEndData.bind(this)}
              startPosition={startPosition}
            />
          </Col>
        </Form.Group>
      </Form>
      <Table striped hover className="margin-top-10">
        <thead>
          <TableHead data={data} handleSortState={handleSortState.bind(this)} />
        </thead>
        <tbody>
          {notifyMessageTableData}
        </tbody>
      </Table>
    </div>
  );
};
export default ContentNotificationSearchResult;

